export default {
  "account": {
    "curatedCollections": "Курирани колекции",
    "curatedCollectionsInfo": "По-долу можете да намерите всички колекции, които имате куратор",
    "editProfile": "Редактиране на профила",
    "likes": "Харесвания",
    "linkAccount": "Моят профил",
    "linkLogin": "Влизане",
    "linkLoginJoin": "Вход/Регистрация",
    "linkLogout": "Излизане",
    "myProfile": "Моят профил",
    "notifications": {
      "loggedIn": "Вече сте влезли в системата. Добре дошли!",
      "loggedOut": "Вече сте излезли.",
      "noCollections": {
        "curated": "Все още не сте курирали никакви колекции",
        "private": "Все още не сте създали никакви лични галерии",
        "public": "Все още не сте създали никакви публични галерии"
      },
      "noLikedItems": "Все още не сте харесали никакви елементи"
    },
    "privateCollections": "Лични галерии",
    "profile": "Моите харесвания и галерии",
    "profileSettings": "Настройки на профила",
    "publicCollections": "Публични галерии",
    "settings": "Настройки",
    "title": "Моят профил"
  },
  "actions": {
    "accept": "Приемете",
    "cancel": "Отказ",
    "close": "затвори",
    "continue": "продължи",
    "download": "Изтегляне",
    "edit": "Редактиране",
    "feedback": "Обратна връзка",
    "goBack": "Назад",
    "goHome": "Отидете на началната страница",
    "learnMore": "Научете повече",
    "like": "Харесвам",
    "move": "Ход",
    "next": "Следваща",
    "pin": "Щифт",
    "preview": "Преглед",
    "previous": "Предишна",
    "providedBy": "Предоставено от {provider}",
    "reject": "Отхвърляне",
    "save": "Запазете",
    "send": "Изпрати",
    "share": "Споделяне",
    "shareOn": "Споделяне в/във {social}",
    "skip": "Пропуснете",
    "viewAt": "Преглед на {link}",
    "viewDocument": "Преглед на документа"
  },
  "attribution": {
    "country": "Държава:",
    "creator": "Създател:",
    "date": "Дата:",
    "institution": "Институция:",
    "title": "Заглавие:"
  },
  "automatedCardGroup": {
    "item": "Скорошни елементи",
    "organisation": "Организации",
    "place": "Места",
    "time": "Представени векове",
    "topic": "Представени теми"
  },
  "blog": {
    "author": "Автор",
    "authors": "Автори",
    "blog": "Блог",
    "by": "от",
    "categories": "Категории",
    "category": "Категория",
    "posts": "Публикации в блогове",
    "published": "Публикувано на {date}",
    "relatedPosts": "Подобни публикации"
  },
  "cardLabels": {
    "organisation": "Организация",
    "person": "човек",
    "place": "място",
    "theme": "Тема",
    "time": "Век",
    "topic": "Тема"
  },
  "clearAllFilters": "изчистване на всички филтри",
  "collections": {
    "actions": {
      "edit": "Редактиране на колекция",
      "update": "Актуализиране на колекция"
    },
    "fashion": {
      "facets": {
        "CREATOR": {
          "moreName": "дизайнери",
          "name": "Дизайнер | Дизайнери",
          "select": "Изберете дизайнери"
        },
        "proxy_dc_format": {
          "moreName": "техники",
          "name": "Техника | Техники",
          "select": "Изберете техники"
        },
        "proxy_dc_type": {
          "moreName": "типове артикули",
          "name": "Вид елемент | Видове елементи",
          "select": "Изберете типове артикули"
        },
        "proxy_dcterms_medium": {
          "moreName": "материали",
          "name": "Материал | Материали",
          "select": "Изберете материали"
        }
      }
    },
    "form": {
      "description": "Описание"
    },
    "notifications": {
      "update": "Колекцията е актуализирана"
    }
  },
  "collectionsYouMightLike": "Колекции, които може да ви харесат",
  "colourSwatch": "Цветен образец",
  "contentYouMightLike": "Съдържание, което може да ви хареса",
  "contentfulManual": {
    "footerNavigation": {
      "MoreInfoLabel": "Повече информация",
      "about": "Относно колекциите на Europeana",
      "forDevelopers": "За разработчици",
      "help": "Помощ",
      "meetUs": "Запознайте се с екипа",
      "provide": "Станете доставчик на данни",
      "subscribe": "Абонирайте се за нашия бюлетин",
      "terms": "Условия за ползване и Политика за поверителност"
    },
    "headerNavigation": {
      "Collections": "Колекции",
      "explore": "Проучи",
      "teachers": "Учители"
    }
  },
  "curatedAutomatically": "Автоматично организирано от Europeana",
  "dateFilter": {
    "endDate": "Крайна дата",
    "specificDate": "Конкретна дата",
    "startDate": "Начална дата",
    "to": "до"
  },
  "debug": {
    "apiRequests": {
      "apiKeyLinkText": "Europeana API ключ",
      "noRequests": "На тази страница не са използвани заявки към API на Europeana.",
      "settingsPageLinkText": "страница с настройки",
      "tip": "Съвет: ако вече имате {apiKeyLink} , можете да го въведете в {settingsPageLink} и той ще бъде включен в тези връзки за заявка към API.",
      "title": "API заявки"
    },
    "debug": "Отстраняване на грешки",
    "settings": {
      "form": {
        "apiKey": {
          "description": "Въведете своя Europeana API ключ и той ще бъде използван във връзките към заявки за API.",
          "label": "API ключ"
        },
        "enabled": {
          "description": "Ако е активирано, менюто за отстраняване на грешки ще се покаже в долния колонтитул на страницата.",
          "label": "Активиране на менюто за отстраняване на грешки"
        }
      },
      "title": "Настройки"
    }
  },
  "delete": "Изтриване",
  "depiction": "Изображение на {title}",
  "directions": {
    "left": "Ляво",
    "right": "Дясно"
  },
  "edmIsShownAtLinkAlt": "Преглед на уебсайта на доставчика",
  "entity": {
    "actions": {
      "cancel": "Отмяна на",
      "pin": "Щифт елемент",
      "unpin": "Освободете елемента",
      "viewPinned": "Вижте закачени елементи"
    },
    "labels": {
      "entity": "Субект"
    },
    "notifications": {
      "deleted": "Галерията ви беше изтрита.",
      "error": {
        "unpin": "Възникна грешка при откачането на елемента. Моля, опитайте отново или докладвайте за проблема."
      },
      "pin": "Този елемент ще се показва в горната част на колекцията „ {entity} “. Ще ви уведомим, когато тази промяна ще бъде видима на страницата за събиране.",
      "pinLimit": {
        "body": "Засега можете да закачите само 24 елемента на първата страница. Ако искате да закачите този елемент, не забравяйте да откачите друг елемент и след това да опитате да закачите този отново.",
        "title": "Твърде много фиксирани елементи"
      },
      "pinned": "Елементът е закачен. Сега той се намира в горната част на първата страница на тази колекция. Възможно е да отнеме до 24 часа, за да се появи за всички.",
      "select": "Изберете свързан обект, за да фиксирате/откачите елемента към/от него.",
      "unpin": "Този елемент ще спре да се показва в горната част на колекцията „ {entity} “. Ще ви уведомим, когато тази промяна ще бъде видима на страницата за събиране.",
      "unpinned": "Елементът е премахнат. Той вече не се намира в горната част на първата страница на тази колекция. Може да отнеме до 24 часа да изчезне за всички."
    }
  },
  "error": "Грешка",
  "errorMessage": {
    "galleryUnauthorised": {
      "description": "Това не е възможно, тъй като частните галерии са видими само за техния създател. Ако познавате създателя на галерията, помолете го да направи галерията публична. Друга възможност е да докладвате за този проблем чрез бутона за обратна връзка.",
      "metaTitle": "Галерията е неоторизирана",
      "title": "Опа! {newline} Опитвате се да видите личната галерия на друг човек."
    },
    "itemNotFound": {
      "description": "Това може да се дължи на следните причини: този елемент не съществува или; беше отменено публикуването му, защото не отговаряше на нашите критерии за качество, или; той беше актуализиран и публикуван отново с нов уникален идентификатор, в който случай опитайте да намерите елемента отново.",
      "metaTitle": "Артикулът не е намерен",
      "title": "О, не! {newline} Не успяхме да намерим този артикул."
    }
  },
  "exhibitions": {
    "chapters": "Глави",
    "credits": "Автори",
    "currentChapter": "Настояща глава",
    "description": "Разгледайте изложбите",
    "exhibitions": "Изложения"
  },
  "explore": "Разгледайте",
  "facets": {
    "COLOURPALETTE": {
      "moreName": "цветове",
      "name": "Цвят | Цветове",
      "options": {
        "#000000": "Черно",
        "#000080": "Тъмносин",
        "#00008B": "Тъмно синьо",
        "#0000CD": "Средно синьо",
        "#0000FF": "Син",
        "#006400": "Тъмнозелено",
        "#008000": "Уеб зелено",
        "#008080": "примкар",
        "#008B8B": "Тъмен циан",
        "#00BFFF": "Дълбоко небесно синьо",
        "#00CED1": "Тъмно тюркоаз",
        "#00FA9A": "Средно пролетно зелено",
        "#00FF00": "зелен",
        "#00FF7F": "Пролетно зелено",
        "#00FFFF": "Циан",
        "#191970": "Среднощно синьо",
        "#1E90FF": "Опасно синьо (Dodger Blue)",
        "#20B2AA": "Светло морско зелено",
        "#228B22": "Горско зелено",
        "#2E8B57": "Морско зелено",
        "#2F4F4F": "Тъмно шисти сиво",
        "#32CD32": "Лайм зелен",
        "#3CB371": "Средно морско зелено",
        "#40E0D0": "тюркоаз",
        "#4169E1": "Кралско синьо",
        "#4682B4": "Стоманено синьо",
        "#483D8B": "Тъмно шисти синьо",
        "#48D1CC": "Среден тюркоаз",
        "#4B0082": "индиго",
        "#556B2F": "Тъмно маслинено зелено",
        "#5F9EA0": "Кадетско синьо",
        "#6495ED": "метличина",
        "#663399": "Rebecca Purple",
        "#66CDAA": "Среден аквамарин",
        "#696969": "Дим Грей",
        "#6A5ACD": "Синя ширина",
        "#6B8E23": "Мрачно маслинено (Olive Drab)",
        "#708090": "Шифер Сив",
        "#778899": "Светло шисто сиво",
        "#7B68EE": "Средно шистов син",
        "#7CFC00": "Тревна зелена",
        "#7F0000": "Уеб Maroon",
        "#7F007F": "Уеб лилаво",
        "#7FFF00": "резеда",
        "#7FFFD4": "аквамарин",
        "#800000": "Бордо (Maroon)",
        "#800080": "Лилаво",
        "#808000": "маслина",
        "#808080": "Web Grey",
        "#87CEEB": "Небесно синьо",
        "#87CEFA": "Светло небесно синьо",
        "#8A2BE2": "Синя виолетова",
        "#8B0000": "Тъмно червено",
        "#8B008B": "Тъмната магента",
        "#8B4513": "Каубойско кафяво (Saddle Brown)",
        "#8FBC8F": "Тъмно морско зелено",
        "#90EE90": "Светло зелено",
        "#9370DB": "Средно лилаво",
        "#9400D3": "Тъмно виолетово",
        "#98FB98": "Бледо зелено",
        "#9932CC": "Тъмна орхидея (Dark Orchid)",
        "#9ACD32": "Жълто зелен",
        "#A020F0": "Лилаво",
        "#A0522D": "Сиена (Sienna)",
        "#A52A2A": "кафяв",
        "#A9A9A9": "Тъмно сив",
        "#ADD8E6": "Светло синьо",
        "#ADFF2F": "Зелено жълто",
        "#AFEEEE": "Бледо тюркоазено",
        "#B03060": "Бордо (Maroon)",
        "#B0C4DE": "Светло стоманено синьо (Light Steel Blue)",
        "#B0E0E6": "Прахово синьо",
        "#B22222": "огнеупорна тухла",
        "#B8860B": "Тъмен златник (Dark Goldenrod)",
        "#BA55D3": "Средна орхидея (Medium Orchid)",
        "#BC8F8F": "Рози Браун",
        "#BDB76B": "Тъмни Хаки",
        "#BEBEBE": "сив",
        "#C0C0C0": "сребърен",
        "#C71585": "Средно виолетово-червено",
        "#CD5C5C": "Индийско червено (Indian Red)",
        "#CD853F": "Перу",
        "#D2691E": "Шоколад",
        "#D2B48C": "тен",
        "#D3D3D3": "светло сив",
        "#D8BFD8": "магарешки бодил",
        "#DA70D6": "орхидея",
        "#DAA520": "Goldenrod",
        "#DB7093": "Бледо виолетово червено",
        "#DC143C": "пурпурен",
        "#DCDCDC": "Сиво (Gainsboro)",
        "#DDA0DD": "слива",
        "#DEB887": "Burlywood",
        "#E0FFFF": "Светъл циан",
        "#E6E6FA": "лавандула",
        "#E9967A": "Тъмна сьомга",
        "#EE82EE": "виолетов",
        "#EEE8AA": "Блед Голденрод",
        "#F08080": "Светъл корал (Light Coral)",
        "#F0E68C": "каки",
        "#F0F8FF": "Бледо синьо (Alice Blue)",
        "#F0FFF0": "медена",
        "#F0FFFF": "лазурен",
        "#F4A460": "Санди Браун",
        "#F5DEB3": "пшеница",
        "#F5F5DC": "бежов",
        "#F5F5F5": "Бял дим",
        "#F5FFFA": "Ментов крем",
        "#F8F8FF": "Ghost White",
        "#FA8072": "сьомга",
        "#FAEBD7": "Антично бяло",
        "#FAF0E6": "бельо",
        "#FAFAD2": "Лек Goldenrod",
        "#FDF5E6": "Стара дантела (Old Lace)",
        "#FF0000": "червен",
        "#FF00FF": "обичка",
        "#FF1493": "Наситено розово (Deep Pink)",
        "#FF4500": "Оранжево червено",
        "#FF6347": "домат",
        "#FF69B4": "Ярко розово (Hot Pink)",
        "#FF7F50": "корал",
        "#FF8C00": "Тъмно оранжево",
        "#FFA07A": "Светла сьомга (Light Salmon)",
        "#FFA500": "оранжев",
        "#FFB6C1": "Светло розово",
        "#FFC0CB": "розов",
        "#FFD700": "злато",
        "#FFDAB9": "Прасковено (Peach Puff)",
        "#FFDEAD": "Навахо Уайт",
        "#FFE4B5": "Мокасини (Moccasin)",
        "#FFE4C4": "Крем супа (Bisque)",
        "#FFE4E1": "Misty Rose",
        "#FFEBCD": "Бланширан бадем",
        "#FFEFD5": "Папая камшик",
        "#FFF0F5": "Руж от лавандула",
        "#FFF5EE": "Мида",
        "#FFF8DC": "свила",
        "#FFFACD": "Лимон шифон",
        "#FFFAF0": "Цветен бял",
        "#FFFAFA": "сняг",
        "#FFFF00": "жълт",
        "#FFFFE0": "Светло жълто",
        "#FFFFF0": "Слонова кост",
        "#FFFFFF": "бял"
      },
      "select": "Изберете цветове"
    },
    "COUNTRY": {
      "name": "Предоставяне на държава",
      "options": {
        "Albania": "Албания",
        "Austria": "Австрия",
        "Belarus": "Беларус",
        "Belgium": "Белгия",
        "Bosnia and Herzegovina": "Босна и Херцеговина",
        "Bulgaria": "България",
        "Croatia": "Хърватия",
        "Cyprus": "Кипър",
        "Czech Republic": "Чешка република",
        "Denmark": "Дания",
        "Estonia": "Естония",
        "Europe": "Европа",
        "Finland": "Финландия",
        "France": "Франция",
        "Georgia": "Грузия",
        "Germany": "Германия",
        "Greece": "Гърция",
        "Holy See (Vatican City State)": "Светия престол (държава Ватикана)",
        "Hungary": "Унгария",
        "Iceland": "Исландия",
        "Ireland": "Ирландия",
        "Israel": "Израел",
        "Italy": "Италия",
        "Latvia": "Латвия",
        "Lithuania": "Литва",
        "Luxembourg": "Люксембург",
        "Macedonia": "Македония",
        "Malta": "Малта",
        "Moldova": "Молдова",
        "Montenegro": "Черна гора",
        "Netherlands": "Холандия",
        "Norway": "Норвегия",
        "Poland": "Полша",
        "Portugal": "Португалия",
        "Romania": "Румъния",
        "Russia": "Русия",
        "Serbia": "Сърбия",
        "Slovakia": "Словакия",
        "Slovenia": "Словения",
        "Spain": "Испания",
        "Sweden": "Швеция",
        "Switzerland": "Швейцария",
        "Turkey": "Турция",
        "Ukraine": "Украйна",
        "United Kingdom": "Великобритания",
        "United States of America": "Съединени Американски щати"
      },
      "select": "Изберете предоставящи държави"
    },
    "CREATOR": {
      "moreName": "създатели",
      "name": "Създател | Създатели",
      "select": "Изберете създатели"
    },
    "DATA_PROVIDER": {
      "moreName": "институции",
      "name": "Институция",
      "select": "Изберете институции"
    },
    "IMAGE_ASPECTRATIO": {
      "name": "Ориентация на изображението | Ориентации на изображенията",
      "options": {
        "landscape": "Хоризонтална",
        "portrait": "Портрет"
      },
      "select": "Изберете ориентации на изображението"
    },
    "IMAGE_SIZE": {
      "name": "Размер на изображението | Размери на изображенията",
      "options": {
        "extra_large": "По-голям 4 MP+ (например 2688 x 1520px)",
        "large": "Голям 1-4 MP (напр. 1920x1080px)",
        "medium": "Среден 0,5-1 MP (например 850x850px)",
        "small": "Малък <0,5 MP (например 650x600px)"
      },
      "select": "Изберете размери на изображението"
    },
    "LANGUAGE": {
      "name": "Език",
      "options": {
        "ar": "Арабски",
        "bg": "Български",
        "bs": "Босненски",
        "ca": "Каталонски",
        "cs": "Чешки",
        "cy": "Уелски",
        "da": "Датски",
        "de": "Немски",
        "el": "Гръцки",
        "en": "Английски",
        "es": "Испански",
        "et": "Естонски",
        "fi": "Финландски",
        "fr": "Френски",
        "ga": "Ирландски",
        "gd": "Гаелски",
        "he": "Иврит",
        "hr": "Хърватски",
        "hu": "Унгарски",
        "is": "Исландски",
        "it": "Италиански",
        "lt": "Литовски",
        "lv": "Латвийски",
        "mk": "Македонски",
        "mt": "Малтийски",
        "mul": "Множество езика",
        "nl": "Холандски",
        "no": "Норвежки",
        "pl": "Полски",
        "pt": "Португалски",
        "ro": "Румънски",
        "ru": "Руски",
        "sk": "Словашки",
        "sl": "Словенски",
        "sq": "Албански",
        "sr": "Сръбски",
        "sv": "Шведски",
        "tr": "Турски",
        "uk": "Украински"
      },
      "select": "Изберете езици"
    },
    "MIME_TYPE": {
      "name": "Формат на файла | Формат на файловете",
      "options": {
        "text/plain": "Само текст"
      },
      "select": "Изберете файлови формати"
    },
    "PROVIDER": {
      "moreName": "агрегатори",
      "name": "Агрегатор",
      "select": "Изберете агрегатори"
    },
    "REUSABILITY": {
      "name": "Мога ли да го използвам повторно?",
      "options": {
        "open": "Да",
        "permission": "Може би, помолете за разрешение",
        "restricted": "Да, при тези условия",
        "uncategorized": "Без категория"
      },
      "select": "Изберете дали можете да използвате това"
    },
    "TYPE": {
      "name": "Вид медия",
      "options": {
        "3D": "3D",
        "IMAGE": "Изображение",
        "SOUND": "Звук",
        "TEXT": "Текст",
        "VIDEO": "Видео"
      },
      "select": "Изберете видове медии"
    },
    "api": {
      "name": "Търсене на",
      "options": {
        "fulltext": "Записи с пълен текст",
        "metadata": "Записи само с метаданни"
      },
      "switch": "Търсете само в съдържанието на елементи с пълен текст",
      "switchMoreInfo": "В тази колекция можете да изберете какво искате да търсите: ако този превключвател е включен, тогава ще търсите в текста на вестника и документа; ако е изключен, тогава вместо това ще търсите в информацията, описваща артикула, точно както винаги правите в повечето други колекции."
    },
    "button": {
      "apply": "Прилагане",
      "cancel": "Отказ",
      "morefilters": "Още филтри",
      "reset": "Нулиране",
      "showAll": "Показване на всичко {label}",
      "showLess": "Показване на по-малко {label}"
    },
    "collection": {
      "name": "Тема",
      "options": {
        "archaeology": "Археология",
        "art": "Изкуство",
        "fashion": "Мода",
        "industrial": "Индустриално наследство",
        "manuscript": "Ръкописи",
        "map": "Карти и география",
        "migration": "Миграция",
        "music": "Музика",
        "nature": "Естествознание ",
        "newspaper": "Вестници",
        "photography": "Фотография",
        "sport": "Спорт",
        "ww1": "Първа световна война"
      },
      "select": "Изберете тема"
    },
    "contentTier": {
      "name": "Качество на артикула",
      "options": {
        "*": "Включва елементи, които не отговарят на нашите критерии за публикуване",
        "0": "Покажи само елементи, които не отговарят на нашите критерии за публикуване",
        "1": "Ниско качество",
        "2": "Средно качество",
        "3": "Високо качество и многократна употреба с условия",
        "4": "Високо качество и свободно многоизползваема"
      },
      "select": "Изберете качества на артикула"
    },
    "moreOptions": "Търсене, за да намерите {0} още {1}.",
    "proxy_dc_format": {
      "name": "Формат | Формати",
      "select": "Изберете формати"
    },
    "proxy_dc_type": {
      "name": "Вид | Видове",
      "select": "Изберете типове"
    },
    "proxy_dcterms_issued": {
      "name": "Дата на издаване"
    },
    "proxy_dcterms_medium": {
      "name": "Медия | Медии",
      "select": "Изберете медия"
    }
  },
  "feedback": {
    "emailOptional": "Може да пожелаем да проследим. Въведете имейл адреса си, ако желаете да се свържем с вас.",
    "failed": "Заявката не е успешна. Моля, опитайте отново.",
    "form": {
      "placeholders": {
        "email": "Въведете вашия имейл адрес",
        "feedback": "Въведете отзивите си тук"
      }
    },
    "policies": "Продължавайки, вие се съгласявате с нашите {0} и потвърждавате нашите {1}.",
    "privacyPolicy": "Политика за поверителност",
    "success": "Вашата обратна връзка е изпратена.",
    "termsOfService": "Условия за ползване",
    "thankYou": "Благодарим ви!",
    "title": "Изпращане на обратна връзка",
    "validEmail": "Въведете валиден имейл адрес",
    "validFeedback": "Вашата обратна връзка трябва да се състои най -малко от 5 думи"
  },
  "fieldLabels": {
    "default": {
      "dcContributor": "Сътрудници",
      "dcCoverage": "Място-време",
      "dcCreator": "Създател",
      "dcDate": "Дата",
      "dcDescription": "Описание",
      "dcDuration": "Продължителност",
      "dcFormat": "Формат",
      "dcIdentifier": "Идентификатор",
      "dcLanguage": "Език",
      "dcPublisher": "Издател",
      "dcRelation": "Отношения",
      "dcRights": "Права",
      "dcSource": "Източник",
      "dcSubject": "Тема",
      "dcTitle": "Заглавие",
      "dcType": "Вид на обекта",
      "dctermsCreated": "Дата на създаване",
      "dctermsExtent": "Степен",
      "dctermsHasPart": "съдържа",
      "dctermsHasVersion": "притежава версия",
      "dctermsIsFormatOf": "е формат на",
      "dctermsIsPartOf": "е част от",
      "dctermsIsReferencedBy": "е посочено от",
      "dctermsIsReplacedBy": "се заменя от",
      "dctermsIsRequiredBy": "изисква се от",
      "dctermsIssued": "Дата на издаване",
      "dctermsMedium": "Среден(а)",
      "dctermsProvenance": "Произход",
      "dctermsReferences": "Препратки",
      "dctermsSpatial": "Места",
      "dctermsTOC": "Таблица на съдържанието",
      "dctermsTemporal": "Времеви",
      "edmCountry": "Предоставяне на държава",
      "edmCurrentLocation": "Настоящо местоположение",
      "edmDataProvider": "Предоставяне на институция",
      "edmHasMet": "отговаря на",
      "edmIncorporates": "включва",
      "edmIntermediateProvider": "Междинен доставчик",
      "edmIsDerivativeOf": "е производно на",
      "edmIsRelatedTo": "Свързано е с",
      "edmIsRepresentationOf": "представлява",
      "edmIsSimilarTo": "наподобява",
      "edmIsSuccessorOf": "е продължение на",
      "edmProvider": "Доставчик",
      "edmRealizes": "Осъзнава",
      "edmRights": "Лиценз на медиите в този запис (освен ако не е посочено друго)",
      "edmUgc": "Генерирано от потребителите съдържание",
      "europeanaCollectionName": "Име на колекцията",
      "keywords": "Ключови думи (предоставени от общността)",
      "timestampCreated": "Времевият печат е създаден",
      "timestampUpdate": "Времевият печат е актуализиран",
      "wasPresentAt": "присъства на",
      "year": "Година"
    },
    "webResource": {
      "about": "Относно RDF",
      "dcDescription": "Описание",
      "ebucoreHasMimeType": "Тип Ebucore MIME",
      "edmRights": "Лиценз за този медиен ресурс",
      "rdfAbout": "Относно RDF"
    }
  },
  "filter": "Филтрирайте",
  "filterResults": "Филтриране на резултати",
  "footer": {
    "customiseWebsiteLanguage": "Персонализиране на езика на уебсайта",
    "disclaimerLine1": "Europeana е инициатива на Европейския съюз, финансирана от Инструмента за свързване на Европа на Европейския съюз и държавите-членки на Европейския съюз. Услугите на Europeana, включително този уебсайт, се управляват от консорциум, ръководен от фондация Europeana по договор за услуга с Европейската комисия.",
    "disclaimerLine2": "Европейската комисия не гарантира точността на информацията и не поема никаква отговорност или отговорност по отношение на информацията на този уебсайт. Нито Европейската комисия, нито каквото и да е лице, действащо от името на Европейската комисия, не носи отговорност или отговорност за точността или използването на информацията на този уебсайт.",
    "findUsElsewhere": "Намерете ни другаде",
    "imageDescription": "Финансиран от Европейския съюз",
    "navigation": {
      "MoreInfoLabel": "Повече информация",
      "about": "За нас",
      "accessibility": "Достъпност",
      "cookies": "Бисквитки",
      "forDevelopers": "За разработчици",
      "help": "Помощ",
      "privacy": "Политика за поверителност",
      "provide": "Станете доставчик на данни",
      "subscribe": "Абонирайте се за нашия бюлетин",
      "terms": "Условия за ползване"
    },
    "ourMission": "Нашата мисия",
    "ourMissionQuote": "Europeana подкрепя сектора на културното наследство в неговата дигитална трансформация. Ние създаваме експертни познания, инструменти и политики, така че да спомогнем за дигиталната промяна и да насърчим партньорства, които развиват иновациите."
  },
  "formatting": {
    "ellipsis": "…",
    "listSeperator": ";"
  },
  "galleries": {
    "description": "Разгледайте нашите галерии",
    "galleries": "Галерии"
  },
  "goToRecord": "Към запис",
  "header": {
    "backToMenu": "Затвори полето за търсене",
    "clearQuery": "Изчистване на заявките за търсене",
    "closeSidebar": "Затвори менюто",
    "entireCollection": "Търсене на {query} в цялата ни колекция",
    "europeanaHome": "Начална страница на Europeana",
    "inCollection": "Търсене на {query} в {collection}",
    "navigation": {
      "about": "За нас",
      "collections": "Колекции",
      "europeanaClassroom": "За учители",
      "help": "Помощ",
      "home": "Начало",
      "pro": "За професионалисти",
      "stories": "Разкази"
    },
    "quickSearch": "Бързо търсене",
    "searchFor": "Търсене на {query}",
    "searchForEverything": "Търсете всичко",
    "searchForEverythingInCollection": "Търсете всичко в {collection}",
    "searchForEverythingInEntireCollection": "Търсете всичко в цялата ни колекция",
    "searchForm": "Формуляр за търсене",
    "showSidebar": "Покажи менюто",
    "sideNavigation": "Странична навигация"
  },
  "homeLinkAlt": "Начална страница на Europeana",
  "homePage": {
    "discoverEditorial": "Последни истории",
    "storiesCTA": "Вижте всички истории",
    "subHeadline": "Търсете, запазвайте и споделяйте изкуство, книги, филми и музика от хиляди културни институции",
    "themesCTA": "Вижте всички теми",
    "themesTitle": "Разгледайте по тема",
    "title": "Открийте {digital} културно наследство на Европа",
    "titleDigital": "дигиталното"
  },
  "imageSlider": {
    "handle": "Манипулатор на плъзгач"
  },
  "items": {
    "itemCount": "1 елемент |{count} елемента",
    "itemOf": "{max} от {count} елемента",
    "recent": "Скорошни елементи",
    "recommended": "Препоръчани елементи",
    "youMightLike": "Елементи, които може да ви харесат"
  },
  "klaro": {
    "main": {
      "acceptAll": "Приемам всичко",
      "acceptSelected": "Приемане на избрани",
      "consentModal": {
        "description": "Ние приемаме сериозно поверителността на вашите данни. Тук можете да оцените и персонализирате услугите, които бихме искали да използваме на този уебсайт. Ти си шефът! Активирайте или деактивирайте услугите, както сметнете за добре.",
        "title": "Услуги, които бихме искали да използваме."
      },
      "consentNotice": {
        "description": "Ние се грижим за вашата поверителност и използваме данни само за подобряване на вашето изживяване. Ние не използваме лична информация за реклама. Можете да промените съгласието си на всеки 15 дни.",
        "learnMore": "Позволете ми да избера"
      },
      "decline": "Отказвам",
      "ok": "добре",
      "purposes": {
        "essential": {
          "description": "Тези услуги са от съществено значение за правилното функциониране на този уебсайт. Те включват изглед на резултатите от търсенето и езикови предпочитания, запазват вписаното състояние и поддържат сигурността на вашето посещение. Не можете да ги деактивирате, тъй като в противен случай уебсайтът не би работил правилно.",
          "title": "Основни услуги за сигурност и персонализиране"
        },
        "usage": {
          "description": "Тези услуги събират информацията, за да ни помогнат да разберем по-добре как уебсайтът се използва и къде са болезнените точки, упълномощавайки ни да направим информиран избор, за да подобрим вашето преживяване.",
          "title": "Услуги за улавяне на използването на уебсайтове и обратна връзка"
        }
      },
      "service": {
        "disableAll": {
          "description": "Използвайте този превключвател, за да активирате или деактивирате всички незадължителни услуги.",
          "title": "Активирайте или деактивирайте всички услуги"
        }
      }
    },
    "services": {
      "abTest": {
        "description": "Помага за подобряване на нашия уебсайт, като периодично прилага експериментални промени.",
        "title": "A/B тестване"
      },
      "auth-strategy": {
        "description": "Спомня си стратегията за оторизация, която да се използва за влизане.",
        "title": "Стратегия за утвърждаване"
      },
      "debugSettings": {
        "description": "Помага за отстраняване на грешки в заявки на API",
        "title": "Превключване за отстраняване на грешки"
      },
      "hotjar": {
        "description": "Активира джаджа за анкета, която ви дава възможност да отговорите на нашите анкети за удовлетвореност на посетителите.",
        "title": "Hotjar"
      },
      "i18n": {
        "description": "Запомня предпочитания от вас език на интерфейса за бъдещ достъп.",
        "title": "Код на езика"
      },
      "jira-servicedesk": {
        "description": "Активира приспособлението за обратна връзка, като ви дава възможност да се свържете с нас.",
        "title": "Бюро за услуги Jira"
      },
      "matomo": {
        "description": "Събира анонимни статистически данни за това как посетителите взаимодействат с уебсайта.",
        "title": "Матомо"
      },
      "newFeatureNotification": {
        "description": "Показва известие, когато станат налични нови функции.",
        "title": "Известие за нова функция"
      },
      "searchResultsView": {
        "description": "Помни, ако предпочитате да виждате резултатите от търсенето в списъчен или решетъчен изглед.",
        "title": "Преглед на резултатите от търсенето (списък / мрежа)"
      }
    }
  },
  "layout": {
    "skipToMain": "Напред към съдържанието на страницата"
  },
  "learnMore": "Научете за източника на това описание",
  "loading": "Зареждане",
  "loadingResults": "Зареждане на резултати",
  "messages": {
    "copyToClipboardSuccess": "Копирано в клипборда",
    "externalContentError": "Външното съдържание не можа да се зареди",
    "notFound": "Не е намерено",
    "paginationLimitExceeded": "Възможно е само да видите първите {limit} резултата от търсенето."
  },
  "modal": {
    "download": {
      "clickToCopy": "Кликнете върху приписването, за да го копирате",
      "modalIntro": "Ако използвате този елемент в мрежата или другаде, не забравяйте да покажете следното приписване до него:",
      "modalTitle": "Кажи Благодаря"
    }
  },
  "multilingual": {
    "automated": "Автоматизиран превод",
    "enrichment": "Обогатяване по партньорски проекти",
    "other": "Други езици",
    "stopTranslating": "Спрете превода на този елемент на {0}.",
    "translateLanguage": "Искате ли да видите този елемент в {0} ?",
    "translateQuotaError": "Услугата за превод временно не е налична. Моля, опитайте отново по-късно."
  },
  "newFeatureNotification": {
    "dismiss": "Отхвърляне",
    "readMore": "Прочетете повече",
    "text": {
      "searchFilters": "Вече можете да търсите стойности в отделните филтри; провери!"
    }
  },
  "newWindow": "отваря се в нов прозорец",
  "noMoreResults": "Няма повече резултати за вашата заявка за търсене.",
  "noResults": "Няма получени резултати",
  "of": "На",
  "organisation": {
    "city": "град",
    "country": "Държава:",
    "englishName": "английско име",
    "nameAcronym": "Акроним на името"
  },
  "pageHasLoaded": "е зареден",
  "pageNumber": "Номер на страницата",
  "pages": {
    "collections": {
      "organisations": {
        "table": {
          "name": "Име"
        },
        "title": "Организации"
      },
      "persons": {
        "title": "Лица"
      },
      "places": {
        "title": "Места"
      },
      "table": {
        "items": "Елементи",
        "name": "Име"
      },
      "times": {
        "title": "времеви периоди"
      },
      "topics": {
        "title": "Теми"
      }
    }
  },
  "pagination": {
    "label": "Пагинация"
  },
  "readMore": "Прочетете повече",
  "recommendation": {
    "prompts": {
      "accept": "Палец нагоре, за да добавите към галерията",
      "reject": "Палец надолу, ако не ви харесва"
    }
  },
  "record": {
    "IIIFViewer": "IIIF зрител",
    "actions": {
      "pin": "Закачване на елемент към налични обекти"
    },
    "allMetaData": "Всички метаданни",
    "copyEmbedLabel": "Вграден код (Щракнете за копиране)",
    "exploreMore": "Разгледайте още",
    "extendedInformation": "Разширена информация",
    "goodToKnow": "Добре е да се знае",
    "hideAll": "Скриване на цялата информация",
    "location": "Местоположение",
    "locationOnMap": "Местоположение на картата",
    "mediaPlayer": "Медиен плейър",
    "record": "Запис",
    "showAll": "Показване на цялата информация",
    "similarItems": "Подобни елементи",
    "status": {
      "unpublished": "[Непубликувани елемент]"
    },
    "transcription": "Транскрипция",
    "transcriptionDisclaimer": "Това съдържание е добавено от обществеността, а не от институцията, която е предоставила този елемент."
  },
  "related": {
    "editorial": {
      "title": "Истории, които може да ви харесат"
    }
  },
  "relatedCollections": "Подобни колекции",
  "removeFilter": "Премахване на филтъра {filterLabel}",
  "reset": "Нулиране",
  "resourceWikimedia": "Източник от Wikimedia Commons",
  "results": "Резултати",
  "resultsFor": "Резултати за {0}",
  "resultsLimitWarning": "Допълнителните резултати не са показани, тъй като са показани само първите 1000 най-подходящи резултата. Ако не сте намерили това, което търсите, моля, помислете за прецизиране на търсенето.",
  "resultsWithin": "Резултати в рамките на {0} {1} за {2}",
  "search": {
    "boost": {
      "placeholder": "Въведете заявка за повишаване на полето"
    },
    "title": "Търсене"
  },
  "searchHasLoaded": "{0} върнати резултати",
  "searchPlaceholder": "Търсене в 50+ милиона артикула",
  "searchResults": "Търсене",
  "searchResultsFor": "{0} – търсене",
  "searchSuggestions": "Предложения за търсене",
  "searchTier": {
    "button": {
      "hide": "Скриване на тези елементи",
      "show": "Показване на тези елементи"
    },
    "text": {
      "hide": "Показват се елементи, които не отговарят на нашите критерии за публикуване.",
      "show": "Повече елементи отговарят на вашето търсене, но не отговарят на нашите критерии за публикуване."
    }
  },
  "searchViews": {
    "grid": "Изглед на мрежа",
    "list": "Изглед на списък",
    "mosaic": "Изглед на мозайка"
  },
  "set": {
    "actions": {
      "addTo": "Добави към галерията",
      "create": "Създай галерия",
      "createNew": "Създай нова галерия",
      "delete": "Изтриване на галерията",
      "edit": "Редактирай галерията",
      "update": "Актуализирай галерията"
    },
    "form": {
      "description": "Описание на галерията",
      "private": "Остави тази галерия лична",
      "required": "задължително поле",
      "title": "Име на галерията"
    },
    "labels": {
      "curatedBy": "Куриран от",
      "private": "Лична галерия"
    },
    "notifications": {
      "deleted": "Галерията ви беше изтрита.",
      "likeLimit": {
        "body": "Съжаляваме, но за момента имате ограничение от 100 елемента, които можете да харесате. Скоро ще премахнем този лимит!",
        "title": "100 харесвания"
      },
      "updated": "Артикулът е добавен в галерията."
    },
    "prompts": {
      "delete": "Сигурни ли сте, че искате да изтриете тази галерия? Ако я изтриете, ще изгубите всички елементи, които сте добавили в нея."
    }
  },
  "showLess": "Показване на по-малко",
  "showMore": "Показване на повече",
  "sideFilters": {
    "noOptions": "Няма налични опции за избор",
    "search": "Търсене"
  },
  "statuses": {
    "liked": "Харесвах",
    "pinned": "Закрепен"
  },
  "storiesPage": {
    "title": "Разкази"
  },
  "website": "Уебсайт",
  "youMightAlsoLike": "Може да харесате също и"
};
